import React, { createContext, useContext, useState, useEffect } from 'react';
import {jwtDecode, JwtPayload } from 'jwt-decode';

interface AuthContextProps {
    isLoggedIn: boolean;
    setIsLoggedIn: (isLoggedIn: boolean) => void;
    username: string | null;
    setUsername: (username: string | null) => void;
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined);

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
    const [username, setUsername] = useState<string | null>(null);

    useEffect(() => {
        const token = localStorage.getItem('token');
        console.log('AuthProvider useEffect - token:', token);

        if (token) {
            const userData = validateToken(token);
            console.log('AuthProvider useEffect - userData:', userData);
            if (userData && userData.username) {
                setIsLoggedIn(true);
                setUsername(userData.username); // Set the username if available
            } else {
                // Remove invalid token and reset auth state
                localStorage.removeItem('token');
                setIsLoggedIn(false);
                setUsername(null);
            }
        }
    }, []);

    useEffect(() => {
        console.log('AuthProvider - isLoggedIn changed:', isLoggedIn);
    }, [isLoggedIn]);

    return (
        <AuthContext.Provider value={{ isLoggedIn, setIsLoggedIn, username, setUsername }}>
            {children}
        </AuthContext.Provider>
    );
};

// Token validation function with username extraction
const validateToken = (token: string): { username: string | null } | null => {
    try {
        const decodedToken = jwtDecode<JwtPayload & { username?: string }>(token);
        console.log('Decoded token:', decodedToken);

        if (decodedToken.exp && decodedToken.exp * 1000 > Date.now()) {
            return { username: decodedToken.username || null };
        } else {
            console.warn('Token expired');
            return null;
        }
    } catch (error) {
        console.error('Error decoding token:', error);
        return null;
    }
};